import * as React from "react";
import { useEffect, useState } from "react";
import { useStore } from "stores/connect";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { getConfig } from "components/configurations/helpers";
import { ConfigurationType } from "components/configurations/ConfigurationTypes";
import { BootstrapModalForm, Button, Input } from "components/bootstrap";
import { IfPermitted } from "components/common";
import Spinner from "components/common/Spinner";
import "moment-duration-format";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
const McpConfig = () => {
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [modalConfig, setModalConfig] = useState(void 0);
  const [viewConfig, setViewConfig] = useState(void 0);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  useEffect(() => {
    ConfigurationsActions.list(ConfigurationType.MCP_CONFIG).then(() => {
      const config = getConfig(ConfigurationType.MCP_CONFIG, configuration);
      setViewConfig(config);
      setModalConfig(config);
    });
  }, [configuration]);
  const openModal = () => {
    setShowConfigModal(true);
  };
  const onModalClickEnableRemoteAccess = () => {
    setModalConfig({ ...modalConfig, enable_remote_access: !modalConfig.enable_remote_access });
  };
  const onModalClickEnableOutputSchema = () => {
    setModalConfig({ ...modalConfig, enable_output_schema: !modalConfig.enable_output_schema });
  };
  const onModalClickEnableInputValidation = () => {
    setModalConfig({ ...modalConfig, enable_input_validation: !modalConfig.enable_input_validation });
  };
  const onModalCancel = () => {
    setShowConfigModal(false);
    setModalConfig(viewConfig);
  };
  const onModalSave = () => {
    ConfigurationsActions.update(ConfigurationType.MCP_CONFIG, { ...modalConfig }).then(() => {
      setShowConfigModal(false);
    });
  };
  if (!viewConfig) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, "MCP Server Configuration"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("p", null, "Activate MCP (Model Context Protocol) to enable LLM-powered communication and automation with your cluster."), /* @__PURE__ */ React.createElement("p", null, "See the", " ", /* @__PURE__ */ React.createElement(DocumentationLink, { text: "MCP connection documentation", page: DocsHelper.PAGES.MCP_SERVER, displayIcon: false }), " ", "for client setup instructions."), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("dl", { className: "deflist" }, /* @__PURE__ */ React.createElement("dt", null, "Remote MCP access"), /* @__PURE__ */ React.createElement("dd", null, viewConfig.enable_remote_access ? "Enabled" : "Disabled"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("dt", null, "Output schema"), /* @__PURE__ */ React.createElement("dd", null, viewConfig.enable_output_schema ? "Enabled" : "Disabled"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("dt", null, "Input validation"), /* @__PURE__ */ React.createElement("dd", null, viewConfig.enable_input_validation ? "Enabled" : "Disabled")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", onClick: openModal }, "Edit configuration")), showConfigModal && modalConfig && /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      bsSize: "large",
      title: "Update MCP Server Configuration",
      onSubmitForm: onModalSave,
      onCancel: onModalCancel,
      submitButtonText: "Update configuration"
    },
    /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "enable-remote-access-checkbox",
        type: "checkbox",
        label: "Enable remote MCP access",
        name: "enabled",
        checked: modalConfig.enable_remote_access,
        onChange: onModalClickEnableRemoteAccess
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "enable-output-schema-checkbox",
        disabled: !modalConfig.enable_remote_access,
        type: "checkbox",
        label: "Enable Output Schema generation",
        name: "output-schema-enabled",
        checked: modalConfig.enable_output_schema,
        onChange: onModalClickEnableOutputSchema
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "enable-input-validation-checkbox",
        disabled: !modalConfig.enable_remote_access,
        type: "checkbox",
        label: "Enable Tool Input Validation",
        name: "input-validation-enabled",
        checked: modalConfig.enable_input_validation,
        onChange: onModalClickEnableInputValidation
      }
    ))
  ));
};
export default McpConfig;
